import { aidenBio, alexanderBio, burgerBio, mrBigBio } from './carrieBios'
// import { aidenProfileReviewTinder, burgerProfileReviewBumble, mrBigProfileReviewHinge } from './carrieProfileReviews'
import { aidenReviewerReviewTinder, mrBigReviewerReviewHinge, burgerReviewerReviewBumble } from './carrieReviewerReviews'

export const aidenReviewerProfile = {
  _id: 'aidenReviewerProfileId',
  userId: 'aidenUserId',
  email: 'aiden@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-aden-2.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...aidenBio },
  profileReviews: [
    // { ...aidenProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...aidenReviewerReviewTinder }
  ],
}

export const alexanderReviewerProfile = {
  _id: 'alexanderReviewerProfileId',
  userId: 'alexanderUserId',
  email: 'alexander@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-alexander-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...alexanderBio },
  profileReviews: [
    
  ],
  reviewerReviews: [

  ],
}

export const burgerReviewerProfile = {
  _id: 'burgerReviewerProfileId',
  userId: 'burgerUserId',
  email: 'burger@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-burger-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...burgerBio },
  profileReviews: [
    // { ...burgerProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...burgerReviewerReviewBumble }
  ],
}

export const mrBigReviewerProfile = {
  _id: 'mrBigReviewerProfileId',
  userId: 'mrBigUserId',
  email: 'mrbig@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-mr-big-1.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...mrBigBio },
  profileReviews: [
    // { ...mrBigProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...mrBigReviewerReviewHinge }
  ],
}